/**
 * Add functionality to all checkboxes with a value of <code>'all'</code> to (de-)select all other corresponding checkboxes (e.g. matches their name-attribute).
 * The toggling checkbox itself gets updated when all other checkboxes are (de-)selected manually by the user.
 */
export async function selectAll() {
    let selectors = document.querySelectorAll('input[type="checkbox"][value="all"]');

    if (selectors.length) {
        let { initSelectAll } = await import(/* webpackMode: "lazy" */ './inc/select-all.async');

        initSelectAll(selectors);
    }
}
